/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Typography } from "@mui/material";
import { formatBytes } from "utils/format-bytes";
import { SelectorGalleryImage } from "./selector-gallery-image";

const ImageCard = (props) => {
    
    const {
        image,
        children,
        selectImage
    } = props || {};
    
    const { width, height, file_size, title } = image;
    const bytes = image ? formatBytes(file_size) : 0;
    const hasDimensions = !!width && !!height;
    const image_width = 236;
    const image_height = 160;

    return (
        <Fragment>
            {image && (
                <div
                    className='image-gallery-item-card'
                    onClick={(e) => selectImage(e, image)}
                >
                    <SelectorGalleryImage
                        image={image}
                        selectImage={selectImage}
                        displayWidth={image_width}
                        displayHeight={image_height}
                    />
                    {/*  full overlay */}
                    <div style={{ padding: "8px", position: "absolute", zIndex: 2, top: 0, width: "100%" }}>
                        {children}
                    </div>
                    
                    {/*  text overlay */}
                    <div style={{
                        padding: "12px 12px",
                        contain: "strict",
                        height: "60px", width: "100%",
                        position: "absolute", zIndex: 2,
                        // top: '80px',
                        bottom: "0px",
                        // background: 'linear-gradient(to top, #00000000, rgba(0,0,0,0))',
                        // border: '1px solid red',
                    }}
                    >
                        <div>
                            <Typography
                                variant='h5'
                                style={{ color: "#FFFFFF", fontWeight: "700",
                                    fontFamily: "Public Sans,sans-serif", fontSize: "12px"
                                }}
                            >
                                {image && title}
                            </Typography>
                            <Typography variant='h6'
                                style={{
                                    // border: '1px solid red',
                                    color: "#E9E9E9", fontWeight: "400",
                                    fontFamily: "Public Sans,sans-serif", fontSize: "11px"
                                }}
                            >
                                Size: {image && bytes}
                                {hasDimensions && <>{" - "}Dimensions: {width}x{height}</>}
                            </Typography>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export { ImageCard };
